class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.resetMs = this.getResetMs();
    this.storageKey = `co-countdown-end:${this.dataset.storageId || 'announcement'}`;
    this.hoursEl = this.querySelector('[data-hours]');
    this.minsEl = this.querySelector('[data-mins]');
    this.secsEl = this.querySelector('[data-secs]');
    this.daysEl = this.querySelector('[data-days]');
    this.endDate = this.resolveEndDate();
    this.render();
    this.interval = setInterval(() => this.render(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  getResetMs() {
    const hours = parseFloat(this.dataset.resetHours);
    const safeHours = Number.isFinite(hours) && hours > 0 ? hours : 24;
    return safeHours * 3600000;
  }

  resolveEndDate() {
    const stored = Number(localStorage.getItem(this.storageKey));
    if (Number.isFinite(stored) && stored > Date.now()) {
      return stored;
    }

    const configured = Date.parse(this.dataset.endDate || '');
    if (Number.isFinite(configured) && configured > Date.now()) {
      localStorage.setItem(this.storageKey, String(configured));
      return configured;
    }

    const nextEnd = Date.now() + this.resetMs;
    localStorage.setItem(this.storageKey, String(nextEnd));
    return nextEnd;
  }

  resetTimer() {
    this.endDate = Date.now() + this.resetMs;
    localStorage.setItem(this.storageKey, String(this.endDate));
  }

  render() {
    let diff = this.endDate - Date.now();

    if (diff <= 0) {
      this.resetTimer();
      diff = this.endDate - Date.now();
    }

    const totalSeconds = Math.floor(diff / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minsEl) this.minsEl.textContent = String(mins).padStart(2, '0');
    if (this.secsEl) this.secsEl.textContent = String(secs).padStart(2, '0');
  }
}

customElements.define('countdown-timer', CountdownTimer);
